/**
 * @generated SignedSource<<d3934e412bbf894dbc1e33f08a2d3b66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type toolbarMenuFragment$data = {
  readonly subscription: {
    readonly tools: {
      readonly isComposerEnabled: boolean;
      readonly isViewerEnabled: boolean;
    } | null;
  } | null;
  readonly user: {
    readonly userID: number;
  };
  readonly " $fragmentType": "toolbarMenuFragment";
};
export type toolbarMenuFragment$key = {
  readonly " $data"?: toolbarMenuFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"toolbarMenuFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "toolbarMenuFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserInfo",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userID",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ZakekeSubscription",
      "kind": "LinkedField",
      "name": "subscription",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZakekeSubscriptionTool",
          "kind": "LinkedField",
          "name": "tools",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isComposerEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isViewerEnabled",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "db7ded51744a5b3c2739088fc1de6d0f";

export default node;
